module.exports = __webpack_public_path__ + "static/media/shutterstock_139244519.1a2cf045.jpg";